import type { EventInfo, EventSpeaker, EventTypes, Participant, SubEvents } from "~/types/api/client/events";

export class EventinfoAPI {
    
    clientId: number | string;
    eventId: number;
    constructor(clientId: number | string, eventId: number){
        this.clientId = clientId;
        this.eventId = eventId
    }

    berlin(){
        console.log("Berlin: ", this.clientId, this.eventId)
    }

    async getEventInfo(subeventid?: number): Promise<EventInfo[] | EventInfo | SubEvents[] | SubEvents | {status: number, message:string}> {
        const response = await $fetch<EventInfo[] | EventInfo | SubEvents[] | SubEvents>(`/api/client/events/eventinfo`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
                eventid: this.eventId,
                subeventid: subeventid
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

    async getEventParticipants(eventdataid: number, participantID?: number): Promise<Participant[] | Participant | {status: number, message:string}> {
        const response = await $fetch<Participant[] | Participant>(`/api/client/events/eventparticipants`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
                eventid: this.eventId,
                eventdataid: eventdataid,
                participantid: participantID
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

    async getEventSpeakers(eventdataid: number): Promise<EventSpeaker[] | {status: number, message:string}> {
        const response = await $fetch<EventSpeaker[]>(`/api/client/events/eventspeaker`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
                eventid: this.eventId,
                eventdataid: eventdataid,
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

    async getAllSpeakers(): Promise<EventSpeaker[] | {status: number, message:string}> {
        const response = await $fetch<EventSpeaker[]>(`/api/client/events/eventspeaker`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

    async getEventTypes(): Promise<EventTypes[] | {status: number, message: string}> {
        const response = await $fetch<EventTypes[]>(`/api/client/events/eventtypes`, {
            headers: useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
                eventid: this.eventId
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

}